module.exports = __webpack_public_path__ + "static/media/wait.0adbcfbe.mp3";